import { render, staticRenderFns } from "./OrdersPlaced.vue?vue&type=template&id=7b677ae2"
import script from "./OrdersPlaced.vue?vue&type=script&lang=js"
export * from "./OrdersPlaced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports